import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Preset from './model';

export const fetchPresets = institutionId => {
    return RESTClient.getAuthenticatedObservable(`v2/discounts/${institutionId}/presets`).map(result => {
        return {
            behaviors: result.behaviors,
            presets: result.discounts.map(preset => Preset.fromAPI(preset, institutionId)),
        };
    });
};

export const updatePresets = (institutionId, discounts) => {
    return RESTClient.putAuthenticatedObservable(`v2/discounts/${institutionId}/presets`, {discounts})
        .map(result => result.discounts)
        .map(presets => presets.map(preset => Preset.fromAPI(preset, institutionId)));
};
